import { Mail } from "lucide-react";

const Home = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <div
        className="w-full min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/portada2.jpg')`,
        }}
      >
        <div className="absolute inset-0 flex flex-col justify-center items-center space-y-2">
          <h1 className="text-white text-3xl md:text-5xl max-w-3xl sm:max-w-7xl text-center mb-4 px-4">
            +10 Años brindando asesoramiento sofisticado a clientes en toda la
            provincia
          </h1>
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=gisebarbero@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="text-white text-base sm:text-xl bg-transparent border hover:bg-white hover:text-black p-3 sm:p-4 flex items-center space-x-2">
              <Mail className="color-white hover:color-black" />
              <p>Contactanos</p>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
